import { Loader } from '@googlemaps/js-api-loader';
import { useContext } from '@nuxtjs/composition-api';

export default function useGoogleMaps() {
  const { $config } = useContext();

  const loader = new Loader({
    apiKey: $config.GOOGLEMAPS_API_KEY,
    version: 'weekly',
    libraries: ['places'],
  });

  return {
    loader,
  };
}
